const en = {
  "nav.discover": "Discover",
  "nav.pools": "Pools",
  "nav.lists": "Lists",
  "nav.about": "About",
  "nav.home": "Home",
  "nav.map": "Map",
  "nav.saved": "Saved",
  "nav.profile": "Profile",
  "nav.primary": "Primary",
  "nav.back": "Back",
  "nav.searchMap": "Search the map",
  "nav.startPool": "Start a pool",

  "set.title": "Settings",
  "set.dark": "Dark background",
  "set.french": "Français",
  "set.about": "About & legal",
  "set.profile": "Profile",
  "set.share": "Share list / Pool",
  "set.join": "Join a pool",
  "set.friends": "Friends",
  "set.logout": "Log out",
  "set.signin": "Sign in",
  "set.install": "Add to Home Screen",
  "set.installDesktop": "Install app",
  "set.installIos": "On iPhone, tap Share, then Add to Home Screen.",
  "set.installChrome": "In Chrome, open the menu and tap Install app.",

  "ban.aria": "Install My Gourmeto",
  "ban.title": "Install Gourmeto",
  "ban.ios": "On iPhone: Share → Add to Home Screen.",
  "ban.chrome": "Chrome menu → Install app.",
  "ban.add": "Add it to your Home Screen.",
  "ban.icon": "Get the app icon on your phone.",
  "ban.install": "Install",
  "ban.later": "Later",

  "login.google": "Continue with Google",
  "login.agree": "By continuing, you agree to the",
  "login.and": "and",

  "home.headline": "Where are we eating today?",
  "home.sub": "Good places. Better together. Decide with people you trust.",
  "home.find": "Find a spot",
  "home.searchHood": "Search a neighbourhood",
  "home.poolTitle": "Start a new pool",
  "home.poolSub": "Let the group vote — no more back-and-forth.",
  "home.curated": "Curated for good taste",
  "home.tonight": "Near you",
  "home.all": "All",

  "map.title": "Discover",
  "map.sub": "Filter by rating, price, or cuisine — then tap a pin.",
  "map.loading": "Loading places…",
  "map.error": "Couldn’t load restaurants.",
  "map.listAria": "Restaurants",
  "map.searchPh": "Search city or postal code",
  "map.search": "Search",
  "map.relocate": "Relocate me",
  "map.loadingAlt": "Finding good places",
  "map.finding": "Finding good places",
  "map.attr": "Toggle attribution",
  "map.powered": "Powered by",
  "map.contributors": "contributors",

  "flt.rating": "Rating",
  "flt.pricing": "Pricing",
  "flt.restaurants": "Restaurants",
  "cui.quebecois": "Quebecois",
  "cui.american": "American",
  "cui.western": "Western European",
  "cui.southern": "Southern European",
  "cui.east": "East Asian",
  "cui.southeast": "Southeast Asian",
  "cui.middle": "Middle Eastern",
  "cui.african": "African",

  "occ.any": "Any",
  "occ.date": "Date",
  "occ.friends": "Friends",
  "occ.work": "Work",
  "occ.guests": "Guests",
  "occ.solo": "Solo",
  "occ.no-regret": "No regret",

  "resto.reserve": "Reserve a table",
  "resto.menu": "View menu",
  "resto.directions": "Get directions",
  "resto.website": "Website",
  "resto.instagram": "Instagram",
  "resto.call": "Call",
  "resto.top": "Top rated",
  "resto.address": "Address",
  "resto.hours": "Hours",
  "resto.phone": "Phone",
  "resto.skip": "Not coming back",
  "resto.skipped": "Saved as not coming back",
  "resto.pickMap": "Select a map:",
  "resto.apple": "Apple Maps",
  "resto.google": "Google Maps",

  "fav.login": "Please sign in to save restaurants.",
  "fav.remove": "Remove from favourites",
  "fav.add": "Add to favourites",
  "fav.alt": "favourite",

  "com.loading": "Loading comments...",
  "com.title": "Comments",
  "com.empty": "No comments yet.",
  "com.editPh": "Edit your comment...",
  "com.writePh": "Write a comment...",
  "com.save": "Save",
  "com.cancel": "Cancel",
  "com.edit": "Edit",
  "com.delete": "Delete",
  "com.post": "Post",
  "com.less": "Read less",
  "com.more": "Read more...",
  "com.login": "Login to leave a comment",
  "com.already": "You already commented here. Edit or delete it first.",
  "com.confirm": "Delete this comment?",
  "com.anon": "Anonymous",

  "saved.title": "Saved",
  "saved.guest": "Sign in to keep favourites, share lists, and start group pools.",
  "saved.lead": "Share a list or start a pool so the group stops debating.",
  "saved.share": "Share list",
  "saved.pool": "Start pool",
  "saved.join": "Join pool",
  "saved.mine": "My favourites",
  "saved.skip": "Not coming back",
  "saved.empty": "No favourites in this filter yet.",
  "saved.none": "None yet.",
  "saved.tip": "Tip: tap cards to select which places go into the list or pool.",
  "saved.nSel": "{n} selected.",
  "saved.copied": "Share link copied. Send it to friends.",
  "saved.noShare": "Could not share",
  "saved.noPool": "Could not create pool",
  "saved.needLoginShare": "Sign in to share a list.",
  "saved.needFavs": "Save some favourites first.",
  "saved.needLoginPool": "Sign in to start a pool.",
  "saved.needTwo": "Select at least 2 restaurants (or save 2+ favourites).",
  "saved.copyLink": "Copy this link:",
  "saved.foodprint": "{name} FoodPrint",
  "saved.picks": "{label} picks",
  "saved.my": "My",
  "saved.poolTitle": "Where should we eat?",

  "list.loading": "Loading list…",
  "list.open": "Open gourmeto",
  "list.public": "Public list",
  "list.shared": "Shared list",
  "list.by": "by {name}",
  "list.places": "{n} places",
  "list.notFound": "List not found",
  "list.fail": "Failed to load",

  "pool.join": "Join a pool",
  "pool.enter": "Enter the code your friend sent.",
  "pool.go": "Join",
  "pool.fromSaved": "Or create one from Saved",
  "pool.loading": "Loading pool…",
  "pool.other": "Try another code",
  "pool.notFound": "Pool not found",
  "pool.fail": "Failed to load pool",
  "pool.voteFail": "Vote failed",
  "pool.closeFail": "Could not close",
  "pool.going": "We're going to",
  "pool.winner": "Winner",
  "pool.winnerVotes": "Winner with {n} vote",
  "pool.winnerVotesN": "Winner with {n} votes",
  "pool.details": "View details",
  "pool.shareResult": "Share result",
  "pool.back": "Back to gourmeto",
  "pool.live": "Live pool",
  "pool.closed": "Closed",
  "pool.hosted": "Hosted by {name}",
  "pool.friend": "a friend",
  "pool.voting": "{n} voting",
  "pool.votes": "{n} votes",
  "pool.yourName": "Your name",
  "pool.shareInvite": "Share invite link",
  "pool.reveal": "Close & reveal winner",
  "pool.submitted": "Vote submitted",
  "pool.tap": "Tap a place to vote — you can change it while the pool is open.",
  "pool.vote1": "{n} vote",
  "pool.voteN": "{n} votes",
  "pool.confirm": "Close this pool and lock the winner?",
  "pool.copied": "Link copied — send it in WhatsApp or iMessage.",
  "pool.copy": "Copy this link:",
  "pool.guest": "Guest",

  "pro.loading": "Loading…",
  "pro.kicker": "Your table awaits",
  "pro.title": "Sign in to gourmeto",
  "pro.copy": "Save favourites, share lists with guests, and settle dinner with a pool.",
  "pro.sub": "Friends, FoodPrint & feed",
  "pro.friends": "Friends",
  "pro.foodprint": "FoodPrint",
  "pro.lists": "Lists",
  "pro.pools": "Pools",

  "feed.pending1": "{n} pending friend request • Open",
  "feed.pendingN": "{n} pending friend requests • Open",
  "feed.tip": "Tip: add friends to see their favourites here — or settle dinner with a pool.",
  "feed.stuck": "Stuck deciding?",
  "feed.stuckCopy": "Pick places from Saved, start a pool, and let everyone vote.",
  "feed.fromSaved": "Start from Saved",
  "feed.joinCode": "Join with code",
  "feed.hot": "Hot near you",
  "feed.trending": "Trending",
  "feed.ffav": "Friends’ favourites",
  "feed.fcom": "Friends’ comments",
  "feed.explore": "Explore something new",
  "feed.loadFav": "Loading friends’ favourites…",
  "feed.errFav": "Could not load friends’ favourites.",
  "feed.emptyFav": "When your friends add favourites, they’ll appear here.",
  "feed.emptyCom": "When your friends leave comments, you’ll see them here.",
  "feed.loadRest": "Could not load restaurants.",
  "feed.noNear": "No nearby restaurants found.",
  "feed.viewMap": "View on Map",
  "feed.addFav": "+ Favourite",
  "feed.viewMapTitle": "View on map",
  "feed.addFavTitle": "Add to favourites",
  "feed.noTrend": "No trending restaurants yet.",
  "feed.trendFail": "Failed to load top favourites",
  "feed.likes": "{name} likes",
  "feed.noFriendFav": "No favourites from friends yet.",
  "feed.openResto": "Open restaurant details",
  "feed.friend": "Friend",
  "feed.resto": "Restaurant",
  "feed.noFriendCom": "No comments from friends yet.",
  "feed.picks": "Loading picks…",
  "feed.picksFail": "Couldn’t load restaurants.",
  "feed.km": "km",

  "fr.friends": "Friends",
  "fr.requests": "Requests",
  "fr.searchPh": "Search by name or email",
  "fr.searchTip": "Tip: try a friend's first name, last name, or email.",
  "fr.accept": "Accept",
  "fr.decline": "Decline",
  "fr.cancel": "Cancel",
  "fr.request": "Request",
  "fr.sending": "Sending…",
  "fr.working": "Working…",
  "fr.already": "Already friends",
  "fr.acceptT": "Accept friend request",
  "fr.declineT": "Decline friend request",
  "fr.cancelT": "Cancel outgoing friend request",
  "fr.searchFail": "Search failed",
  "fr.sendFail": "Could not send request",
  "fr.cancelFail": "Could not cancel request",
  "fr.acceptFail": "Failed to accept",
  "fr.declineFail": "Failed to decline",
  "fr.user": "User",
  "fr.unnamed": "Unnamed",
  "fr.refresh": "Refresh",
  "fr.refreshing": "Refreshing...",
  "fr.remove": "Remove",
  "fr.removing": "Removing…",
  "fr.loadFriends": "Loading your friends…",
  "fr.noFriends": "You haven't added any friends yet.",
  "fr.loadFail": "Failed to load friends",
  "fr.removeFail": "Could not remove friend",
  "fr.removeT": "Remove friend",
  "fr.inbox": "Friend requests",
  "fr.incoming": "Incoming",
  "fr.outgoing": "Outgoing",
  "fr.loadIn": "Loading incoming requests…",
  "fr.emptyIn": "No incoming requests right now.",
  "fr.loadOut": "Loading outgoing requests…",
  "fr.emptyOut": "You haven't sent any requests.",
  "fr.canceling": "Canceling…",
  "fr.reqFail": "Failed to load requests",
  "fr.accReqFail": "Failed to accept request",
  "fr.decReqFail": "Failed to decline request",
  "fr.canReqFail": "Failed to cancel request",
  "fr.cancelOutT": "Cancel outgoing request",

  "about.title": "About",
  "about.lead": "Decide where to eat. Good places near you. Better together — your FoodPrint, and group pools with friends.",
  "about.collect": "What we collect",
  "about.collectP": "Only what personalizes your experience: Google name, email, and the restaurants you save or skip. We don’t sell your data for ads.",
  "about.disc": "Disclaimer",
  "about.discP": "Restaurant info comes from public sources and community activity. gourmeto is not affiliated with the restaurants shown.",
  "about.install": "Install the app",
  "about.installP": "Add gourmeto to your Home Screen from Chrome (Android) or Safari → Share → Add to Home Screen (iPhone).",
  "about.contact": "Contact",
  "about.questions": "Questions or feedback:",

  "legal.aria": "Legal",
  "legal.privacy": "Privacy",
  "legal.cookies": "Cookies",
  "legal.terms": "Terms",
  "legal.updated": "Last updated",

  "fp.title": "Coming soon",
  "fp.copy": "This feature is on the way. Stay tuned.",
};

const fr = {
  "nav.discover": "Découvrir",
  "nav.pools": "Pools",
  "nav.lists": "Listes",
  "nav.about": "À propos",
  "nav.home": "Accueil",
  "nav.map": "Carte",
  "nav.saved": "Listes",
  "nav.profile": "Profil",
  "nav.primary": "Principal",
  "nav.back": "Retour",
  "nav.searchMap": "Chercher sur la carte",
  "nav.startPool": "Lancer un pool",

  "set.title": "Réglages",
  "set.dark": "Fond sombre",
  "set.french": "Français",
  "set.about": "À propos et mentions",
  "set.profile": "Profil",
  "set.share": "Partager une liste / Pool",
  "set.join": "Rejoindre un pool",
  "set.friends": "Amis",
  "set.logout": "Déconnexion",
  "set.signin": "Connexion",
  "set.install": "Ajouter à l’écran d’accueil",
  "set.installDesktop": "Installer l’app",
  "set.installIos": "Sur iPhone : Partager, puis Sur l’écran d’accueil.",
  "set.installChrome": "Dans Chrome, ouvrez le menu et touchez Installer l’app.",

  "ban.aria": "Installer My Gourmeto",
  "ban.title": "Installer Gourmeto",
  "ban.ios": "Sur iPhone : Partager → Sur l’écran d’accueil.",
  "ban.chrome": "Menu Chrome → Installer l’app.",
  "ban.add": "Ajoutez-la à votre écran d’accueil.",
  "ban.icon": "L’icône de l’app, sur votre téléphone.",
  "ban.install": "Installer",
  "ban.later": "Plus tard",

  "login.google": "Continuer avec Google",
  "login.agree": "En continuant, vous acceptez les",
  "login.and": "et la",

  "home.headline": "On mange où aujourd’hui ?",
  "home.sub": "De bonnes adresses. Ensemble, c’est mieux. Décidez avec des gens de confiance.",
  "home.find": "Trouver une adresse",
  "home.searchHood": "Chercher un quartier",
  "home.poolTitle": "Lancer un nouveau pool",
  "home.poolSub": "Le groupe vote — fini le ping-pong de messages.",
  "home.curated": "Sélectionnés pour le goût",
  "home.tonight": "Près de vous",
  "home.all": "Tous",

  "map.title": "Découvrir",
  "map.sub": "Filtrez par note, prix ou cuisine — puis touchez une épingle.",
  "map.loading": "Chargement des adresses…",
  "map.error": "Impossible de charger les restos.",
  "map.listAria": "Restaurants",
  "map.searchPh": "Ville ou code postal",
  "map.search": "Chercher",
  "map.relocate": "Me recentrer",
  "map.loadingAlt": "On cherche de bonnes adresses",
  "map.finding": "On cherche de bonnes adresses",
  "map.attr": "Afficher les crédits",
  "map.powered": "Propulsé par",
  "map.contributors": "contributeurs",

  "flt.rating": "Note",
  "flt.pricing": "Prix",
  "flt.restaurants": "Restaurants",
  "cui.quebecois": "Québécois",
  "cui.american": "Américain",
  "cui.western": "Europe de l’Ouest",
  "cui.southern": "Europe du Sud",
  "cui.east": "Asie de l’Est",
  "cui.southeast": "Asie du Sud-Est",
  "cui.middle": "Moyen-Orient",
  "cui.african": "Africain",

  "occ.any": "Tous",
  "occ.date": "Date",
  "occ.friends": "Amis",
  "occ.work": "Travail",
  "occ.guests": "Invités",
  "occ.solo": "Solo",
  "occ.no-regret": "Sans regret",

  "resto.reserve": "Réserver une table",
  "resto.menu": "Voir le menu",
  "resto.directions": "Itinéraire",
  "resto.website": "Site web",
  "resto.instagram": "Instagram",
  "resto.call": "Appeler",
  "resto.top": "Coup de cœur",
  "resto.address": "Adresse",
  "resto.hours": "Heures",
  "resto.phone": "Téléphone",
  "resto.skip": "On n’y retourne pas",
  "resto.skipped": "Marqué : on n’y retourne pas",
  "resto.pickMap": "Choisir une carte :",
  "resto.apple": "Plans Apple",
  "resto.google": "Google Maps",

  "fav.login": "Connectez-vous pour enregistrer des restos.",
  "fav.remove": "Retirer des favoris",
  "fav.add": "Ajouter aux favoris",
  "fav.alt": "favori",

  "com.loading": "Chargement des commentaires...",
  "com.title": "Commentaires",
  "com.empty": "Pas encore de commentaires.",
  "com.editPh": "Modifier votre commentaire...",
  "com.writePh": "Écrire un commentaire...",
  "com.save": "Enregistrer",
  "com.cancel": "Annuler",
  "com.edit": "Modifier",
  "com.delete": "Supprimer",
  "com.post": "Publier",
  "com.less": "Réduire",
  "com.more": "Lire plus...",
  "com.login": "Connectez-vous pour commenter",
  "com.already": "Vous avez déjà commenté. Modifiez ou supprimez d’abord.",
  "com.confirm": "Supprimer ce commentaire ?",
  "com.anon": "Anonyme",

  "saved.title": "Listes",
  "saved.guest": "Connectez-vous pour garder vos favoris, partager des listes et lancer un pool.",
  "saved.lead": "Partagez une liste ou lancez un pool — le groupe arrête de débattre.",
  "saved.share": "Partager la liste",
  "saved.pool": "Lancer un pool",
  "saved.join": "Rejoindre",
  "saved.mine": "Mes favoris",
  "saved.skip": "On n’y retourne pas",
  "saved.empty": "Aucun favori dans ce filtre.",
  "saved.none": "Rien pour l’instant.",
  "saved.tip": "Astuce : touchez les cartes pour choisir ce qui va dans la liste ou le pool.",
  "saved.nSel": "{n} sélectionné(s).",
  "saved.copied": "Lien copié. Envoyez-le à vos amis.",
  "saved.noShare": "Impossible de partager",
  "saved.noPool": "Impossible de créer le pool",
  "saved.needLoginShare": "Connectez-vous pour partager une liste.",
  "saved.needFavs": "Enregistrez d’abord quelques favoris.",
  "saved.needLoginPool": "Connectez-vous pour lancer un pool.",
  "saved.needTwo": "Choisissez au moins 2 restos (ou enregistrez-en 2 et plus).",
  "saved.copyLink": "Copiez ce lien :",
  "saved.foodprint": "FoodPrint de {name}",
  "saved.picks": "Choix {label}",
  "saved.my": "Mon",
  "saved.poolTitle": "On mange où ?",

  "list.loading": "Chargement de la liste…",
  "list.open": "Ouvrir gourmeto",
  "list.public": "Liste publique",
  "list.shared": "Liste partagée",
  "list.by": "par {name}",
  "list.places": "{n} adresses",
  "list.notFound": "Liste introuvable",
  "list.fail": "Échec du chargement",

  "pool.join": "Rejoindre un pool",
  "pool.enter": "Entrez le code que votre ami vous a envoyé.",
  "pool.go": "Rejoindre",
  "pool.fromSaved": "Ou créez-en un depuis Listes",
  "pool.loading": "Chargement du pool…",
  "pool.other": "Essayer un autre code",
  "pool.notFound": "Pool introuvable",
  "pool.fail": "Impossible de charger le pool",
  "pool.voteFail": "Vote impossible",
  "pool.closeFail": "Impossible de fermer",
  "pool.going": "On y va",
  "pool.winner": "Gagnant",
  "pool.winnerVotes": "Gagnant avec {n} vote",
  "pool.winnerVotesN": "Gagnant avec {n} votes",
  "pool.details": "Voir la fiche",
  "pool.shareResult": "Partager le résultat",
  "pool.back": "Retour à gourmeto",
  "pool.live": "Pool en cours",
  "pool.closed": "Fermé",
  "pool.hosted": "Organisé par {name}",
  "pool.friend": "un ami",
  "pool.voting": "{n} en train de voter",
  "pool.votes": "{n} votes",
  "pool.yourName": "Votre nom",
  "pool.shareInvite": "Partager le lien",
  "pool.reveal": "Fermer et révéler le gagnant",
  "pool.submitted": "Vote envoyé",
  "pool.tap": "Touchez une adresse pour voter — vous pouvez changer tant que le pool est ouvert.",
  "pool.vote1": "{n} vote",
  "pool.voteN": "{n} votes",
  "pool.confirm": "Fermer ce pool et verrouiller le gagnant ?",
  "pool.copied": "Lien copié — envoyez-le sur WhatsApp ou iMessage.",
  "pool.copy": "Copiez ce lien :",
  "pool.guest": "Invité",

  "pro.loading": "Chargement…",
  "pro.kicker": "Votre table vous attend",
  "pro.title": "Connectez-vous à gourmeto",
  "pro.copy": "Gardez vos favoris, partagez des listes et réglez le souper avec un pool.",
  "pro.sub": "Amis, FoodPrint et fil",
  "pro.friends": "Amis",
  "pro.foodprint": "FoodPrint",
  "pro.lists": "Listes",
  "pro.pools": "Pools",

  "feed.pending1": "{n} demande d’ami en attente • Ouvrir",
  "feed.pendingN": "{n} demandes d’ami en attente • Ouvrir",
  "feed.tip": "Astuce : ajoutez des amis pour voir leurs favoris — ou réglez le souper avec un pool.",
  "feed.stuck": "Vous n’arrivez pas à choisir ?",
  "feed.stuckCopy": "Choisissez des adresses dans Listes, lancez un pool, et tout le monde vote.",
  "feed.fromSaved": "Partir des listes",
  "feed.joinCode": "Rejoindre avec un code",
  "feed.hot": "Près de vous",
  "feed.trending": "Tendances",
  "feed.ffav": "Favoris des amis",
  "feed.fcom": "Commentaires des amis",
  "feed.explore": "Explorer autre chose",
  "feed.loadFav": "Chargement des favoris des amis…",
  "feed.errFav": "Impossible de charger les favoris des amis.",
  "feed.emptyFav": "Quand vos amis ajoutent des favoris, ils apparaîtront ici.",
  "feed.emptyCom": "Quand vos amis commentent, vous les verrez ici.",
  "feed.loadRest": "Impossible de charger les restos.",
  "feed.noNear": "Aucun resto à proximité.",
  "feed.viewMap": "Voir sur la carte",
  "feed.addFav": "+ Favori",
  "feed.viewMapTitle": "Voir sur la carte",
  "feed.addFavTitle": "Ajouter aux favoris",
  "feed.noTrend": "Pas encore de tendances.",
  "feed.trendFail": "Impossible de charger les favoris populaires",
  "feed.likes": "{name} aime",
  "feed.noFriendFav": "Pas encore de favoris d’amis.",
  "feed.openResto": "Ouvrir la fiche",
  "feed.friend": "Ami",
  "feed.resto": "Restaurant",
  "feed.noFriendCom": "Pas encore de commentaires d’amis.",
  "feed.picks": "Chargement des choix…",
  "feed.picksFail": "Impossible de charger les restos.",
  "feed.km": "km",

  "fr.friends": "Amis",
  "fr.requests": "Demandes",
  "fr.searchPh": "Chercher par nom ou courriel",
  "fr.searchTip": "Astuce : prénom, nom ou courriel d’un ami.",
  "fr.accept": "Accepter",
  "fr.decline": "Refuser",
  "fr.cancel": "Annuler",
  "fr.request": "Demander",
  "fr.sending": "Envoi…",
  "fr.working": "Un instant…",
  "fr.already": "Déjà amis",
  "fr.acceptT": "Accepter la demande",
  "fr.declineT": "Refuser la demande",
  "fr.cancelT": "Annuler la demande envoyée",
  "fr.searchFail": "Recherche impossible",
  "fr.sendFail": "Impossible d’envoyer la demande",
  "fr.cancelFail": "Impossible d’annuler",
  "fr.acceptFail": "Impossible d’accepter",
  "fr.declineFail": "Impossible de refuser",
  "fr.user": "Utilisateur",
  "fr.unnamed": "Sans nom",
  "fr.refresh": "Actualiser",
  "fr.refreshing": "Actualisation...",
  "fr.remove": "Retirer",
  "fr.removing": "Retrait…",
  "fr.loadFriends": "Chargement de vos amis…",
  "fr.noFriends": "Vous n’avez pas encore d’amis.",
  "fr.loadFail": "Impossible de charger les amis",
  "fr.removeFail": "Impossible de retirer cet ami",
  "fr.removeT": "Retirer l’ami",
  "fr.inbox": "Demandes d’ami",
  "fr.incoming": "Reçues",
  "fr.outgoing": "Envoyées",
  "fr.loadIn": "Chargement des demandes reçues…",
  "fr.emptyIn": "Aucune demande reçue pour le moment.",
  "fr.loadOut": "Chargement des demandes envoyées…",
  "fr.emptyOut": "Vous n’avez envoyé aucune demande.",
  "fr.canceling": "Annulation…",
  "fr.reqFail": "Impossible de charger les demandes",
  "fr.accReqFail": "Impossible d’accepter la demande",
  "fr.decReqFail": "Impossible de refuser la demande",
  "fr.canReqFail": "Impossible d’annuler la demande",
  "fr.cancelOutT": "Annuler la demande envoyée",

  "about.title": "À propos",
  "about.lead": "Décidez où manger. De bonnes adresses près de vous. Ensemble, c’est mieux — votre FoodPrint, et des pools entre amis.",
  "about.collect": "Ce que nous collectons",
  "about.collectP": "Uniquement ce qui personnalise l’expérience : nom Google, courriel, et les restos que vous enregistrez ou écartez. Nous ne vendons pas vos données pour la pub.",
  "about.disc": "Avis",
  "about.discP": "Les infos restos viennent de sources publiques et de l’activité de la communauté. gourmeto n’est pas affilié aux restaurants affichés.",
  "about.install": "Installer l’app",
  "about.installP": "Ajoutez gourmeto à l’écran d’accueil depuis Chrome (Android) ou Safari → Partager → Sur l’écran d’accueil (iPhone).",
  "about.contact": "Contact",
  "about.questions": "Questions ou commentaires :",

  "legal.aria": "Mentions",
  "legal.privacy": "Confidentialité",
  "legal.cookies": "Témoins",
  "legal.terms": "Conditions",
  "legal.updated": "Dernière mise à jour",

  "fp.title": "Bientôt",
  "fp.copy": "Cette fonction arrive. Restez à l’affût.",
};

export const STRINGS = { en, fr };

export function translate(locale, key, vars) {
  const table = STRINGS[locale] || en;
  let s = table[key] ?? en[key] ?? key;
  if (vars) {
    s = s.replace(/\{(\w+)\}/g, (_, k) =>
      vars[k] == null ? "" : String(vars[k]),
    );
  }
  return s;
}
